import env from "@utils/env";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const Api = axios.create({
  baseURL: env.REACT_APP_API_URL ?? "https://apicatalogo.modacentersantacruz.com.br/v1",
  headers,
});

Api.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("user_token");
  if (token && config && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

Api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error.response.data, "error");
    if (error.response?.data?.message === "invalid signature") {
      toast("Sua sessão expirou, faça login novamente");
      localStorage.clear();
      window.location.reload();
    }
    if (error.response?.data?.message === "expired-token") {
      localStorage.clear();
      const handleConfirmRequest = () => {
        confirmAlert({
          closeOnClickOutside: false,
          title: "Atenção",
          message: "Sua sessão expirou, faça login novamente",
          buttons: [
            {
              label: "Ok",
              onClick: () => {
                window.location.href = `/login?redirect=${window.location.pathname}`;
              },
            },
          ],
        });
      };

      handleConfirmRequest();
    }
    return Promise.reject(error);
  }
);

export default Api;
